import { observer } from "mobx-react";
import { OrderCardItemInterface } from "../../interfaces_and_types";
import "./styles.css";
import { Checkbox } from "@mui/material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import { useTranslation } from "react-i18next";
import { LOGO2 } from "../../assets";
import { v4 as uuidv4 } from "uuid";

const OrderCardItem = (props: OrderCardItemInterface) => {
  const { t } = useTranslation();
  const renderSubItemsPrice = () => {
    let price = 0;
    props.item.subItemsCategories.forEach((c) =>
      c.subItems.forEach((s) => (price += s.price)),
    );
    return price;
  };

  return (
    <div className="order-card-item-container">
      <div className="order-card-item-left">
        <Checkbox
          icon={
            props.item.isReady ? (
              <CheckCircle className="CheckCircle" />
            ) : (
              <RadioButtonUnchecked className="UncheckedCircle" />
            )
          }
          checkedIcon={<CheckCircle className="CheckCircle" />}
          style={{
            height: 20,
            width: 20,
            // marginTop: i18n.language === "ar" ? 12 : 6,
            opacity: !props.isPreparing ? (props.item.isReady ? 0.4 : 0.1) : 1,
            borderRadius: 20 / 2,
          }}
          disabled={!props.isPreparing || props.item.isReady}
          onChange={() => props.updateItem(props.item)}
          //checked={props.item.isReady || false}
          value={props.item.isReady}
        />
        <div className="order-card-item-left-imageandtitle-container">
          <img
            className="order-card-item-image"
            src={props.item.image !== null ? props.item.image : LOGO2}
            height={props.item.image === null ? 30 : 60}
            width={props.item.image === null ? 30 : 60}
            style={{
              objectFit: props.item.image === null ? "contain" : "fill",
            }}
            alt=""
          />
        </div>
        <div className="order-card-item-title">
          <div>{t(props.item.title)}</div>
        </div>
        <div className="order-card-item-qty-price">
          <span>{props.item.quantity} x</span>
          <span>
            {(props.item.quantity > 0
              ? props.item.price / props.item.quantity
              : 0) + renderSubItemsPrice()}
            ₪
          </span>
        </div>
      </div>
      {props.item.subItemsCategories.some((c) => c.subItems.length > 0) && (
        <div className="order-card-item-subitems">
          {props.item.subItemsCategories.map(
            (subItemCategory) =>
              subItemCategory.subItems.length > 0 && (
                <span key={uuidv4()}>
                  <strong>{t(subItemCategory.title)}: </strong>
                  {subItemCategory.subItems
                    .map((subItem) => t(subItem.title))
                    .join(", ")}
                </span>
              ),
          )}
        </div>
      )}
    </div>
  );
};

export default observer(OrderCardItem);
